package com.macrofocus.eflux.network.physical

import com.macrofocus.eflux.data.ZonePowerFlowRecord

class Zone(val name: String) {
    constructor(record: ZonePowerFlowRecord) : this(record.zoname)

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false

        other as Zone

        if (name != other.name) return false

        return true
    }

    override fun hashCode(): Int {
        return name.hashCode()
    }

    override fun toString(): String = name
}